<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p><a href="https://github.com/tti0/global-journey">global-journey</a> by Theodore Tucker (<a href="https://tti0.net">tti0</a>)</p>
      <p>Copyright &copy; 2021, Licensed under the MIT License</p>
      <p>Favicon: <a href="https://thenounproject.com/search/?q=1822912&i=1822912">Globe</a> by <a href="https://thenounproject.com/vendetusvectores/">Alvaro Cabrera</a> from <a href="https://thenounproject.com/">The Noun Project</a></p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TheFooter"
};
</script>

<style scoped>

</style>
